import React, { Component } from "react";
import "../../../assets/scss/components/app-loader.scss"

class DotSpinner extends Component {
  render() {
    return (
      <div className="spinner-dot">
        <div className="bounce1"></div>
        <div className="bounce2"></div>
        <div className="bounce3"></div>
      </div>
    );
  }
}

export default DotSpinner;